import React from 'react'
import { Routes, Route } from 'react-router-dom'
import AppNavigation from '@BUP/navigations/AppNavigation'
import PublicRoute from '@BUP/routes/PublicRoute'
import PrivateRoute from '@BUP/routes/PrivateRoute'
import AuthenticatedRoute from '@BUP/routes/authenticated-route'
import LoginPage from '@BUP/pages/Login'
import FirstTimeLogin from '@BUP/components/FirstimeLogin'
import ResetPasswordPage from '@BUP/pages/ResetPasswordPage'
import ConfigureResetPasswordPage from '@BUP/pages/ConfigureResetPasswordPage'
import UserNotFoundPage from '@BUP/pages/error/user-not-found'
import NoOrganizationPage from '@BUP/pages/NoOrganization'
import ChangeGenericPasswordPage from '@BUP/pages/changeGenericPassword'

export default function AuthNavigation () {
  return (
    <Routes>
      <Route
        path='/login'
        element={<LoginPage />}
      />
      <Route
        path='/setup'
        element={<FirstTimeLogin />}
      />
      <Route
        path='/configurepassword'
        element={<FirstTimeLogin />}
      />
      <Route
        path='/recover'
        element={<ResetPasswordPage />}
      />
      <Route
        path='/password-reset'
        element={<ResetPasswordPage />}
      />
      <Route
        path='/unlock'
        element={<ConfigureResetPasswordPage />}
      />
      <Route
        path='/configpassword'
        element={<ConfigureResetPasswordPage />}
      />
      <Route
        path='/user-not-found'
        element={
          <AuthenticatedRoute>
            <UserNotFoundPage />
          </AuthenticatedRoute>
        }
      />
      <Route
        path='/organization-disabled'
        element={
          <AuthenticatedRoute>
            <NoOrganizationPage />
          </AuthenticatedRoute>
        }
      />
      <Route
        path='/update'
        element={
          <PrivateRoute>
            <ChangeGenericPasswordPage />
          </PrivateRoute>
        }
      />
      <Route
        path='/changepassword'
        element={
          <PrivateRoute>
            <ChangeGenericPasswordPage />
          </PrivateRoute>
        }
      />
      <Route
        path='/*'
        element={<PrivateRoute><AppNavigation /></PrivateRoute>}
      />
    </Routes>
  )
}
